<script>
import VTripleTime from "@/components/Task/Widgets/VTripleTime";
import UserService from "@/services/UserService";
import Cloner from "@/libraries/Cloner";
import Messages from "@/mixins/Messages";

export default {
    props: {},
    mixins: [Messages],
    components: { VTripleTime },
    data() {
        return {
            loading: true,
            saving: false,
            user: {
                clock_tgt_mon: 0,
                clock_tgt_tue: 0,
                clock_tgt_wed: 0,
                clock_tgt_thu: 0,
                clock_tgt_fri: 0
            }
        };
    },
    async created() {
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async saveForm() {
            try {
                this.saving = true; 
                await UserService.PUT_setClockTargets(this.user);
                this.$msgSuccess(
                    this.$t(
                        "daylogs.notify_success_new_targets_saved_effective_from_now"
                    )
                );
                await this.fetchData();
            } catch (e) {
                this.$msgError(
                    this.$t(
                        "daylogs.error_sth_went_wrong_when_saving_clock_targets"
                    )
                );
            }

            this.saving = false; 
        },
        async fetchData() {
            try {
                const { data } = await UserService.me();
                this.user = Cloner.pickClone(data.data, [
                    "clock_tgt_mon",
                    "clock_tgt_tue",
                    "clock_tgt_wed",
                    "clock_tgt_thu",
                    "clock_tgt_fri"
                ]);
            } catch (e) {
                console.log("fd e", e);
            }
        }
    }
};
</script>

<template>
    <div>
        <base-header class="pb-1" type="">
            <bread-bag> </bread-bag>
        </base-header>

        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <card body-classes="">
                        <h3>
                            {{
                                $t(
                                    "daylogs.daily_goal_settings_for_clock_module"
                                )
                            }}
                        </h3>
                        <p>{{ $t("daylogs.daily_goal_settings_text") }}</p>
                        <p class="text-warning">
                            <i class="far fa-exclamation-triangle"></i>
                            {{
                                $t(
                                    "daylogs.daily_goal_settings_do_not_work_retrospective_text"
                                )
                            }}
                        </p>
                        <hr />
                        <v-loader :loading="loading" v-if="loading" />
                        <div class="row goal-setters" v-else>
                            <div class="col">
                                <h4>
                                    {{ $t("daylogs.goal_mon") }}
                                </h4>

                                <div class="goal-setters__tt">
                                    <v-triple-time
                                        style="margin-left: auto; margin-right: auto;"
                                        v-model="user.clock_tgt_mon"
                                        :enable-controls="true"
                                        :snap-to="60"
                                        :interval="300"
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <h4>
                                    {{ $t("daylogs.goal_tue") }}
                                </h4>

                                <div class="goal-setters__tt">
                                    <v-triple-time
                                        style="margin-left: auto; margin-right: auto;"
                                        v-model="user.clock_tgt_tue"
                                        :enable-controls="true"
                                        :snap-to="60"
                                        :interval="300"
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <h4>
                                    {{ $t("daylogs.goal_wed") }}
                                </h4>

                                <div class="goal-setters__tt">
                                    <v-triple-time
                                        style="margin-left: auto; margin-right: auto;"
                                        v-model="user.clock_tgt_wed"
                                        :enable-controls="true"
                                        :snap-to="60"
                                        :interval="300"
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <h4>
                                    {{ $t("daylogs.goal_thu") }}
                                </h4>

                                <div class="goal-setters__tt">
                                    <v-triple-time
                                        style="margin-left: auto; margin-right: auto;"
                                        v-model="user.clock_tgt_thu"
                                        :enable-controls="true"
                                        :snap-to="60"
                                        :interval="300"
                                    />
                                </div>
                            </div>
                            <div class="col">
                                <h4>
                                    {{ $t("daylogs.goal_fri") }}
                                </h4>

                                <div class="goal-setters__tt">
                                    <v-triple-time
                                        style="margin-left: auto; margin-right: auto;"
                                        v-model="user.clock_tgt_fri"
                                        :enable-controls="true"
                                        :snap-to="60"
                                        :interval="300"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- .goal-setters -->
                        <div class="text-right mt-5">
                            <base-button :loading="saving" @click="saveForm" type="primary">{{
                                $t("save")
                            }}</base-button>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.goal-setters {
    h4 {
        text-align: center;
    }

    &__tt {
        border-top: 1px solid $gray-300;
        padding-top: 25px;
    }
}
</style>
